import styled from "styled-components";
import { Box, Flex, Heading } from "@edricphan2022/uikit";

import mediaQueries from "../../@uikit/theme/base";

export const Wrapper = styled(Box)`
  width: 100%;
  height: 100%;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right center;
  picture{
    width: 50%;
  }

  .slick-arrow {
    display: none !important;
  }

  .slick-dots-card {
    display: flex !important;
    align-items: center;
    justify-content: center;
    padding-top: 55px;

    button {
      font-size: 0;
      border-radius: 3px;
      width: 20px;
      height: 3px;
      background-color: #b7bdc6;
      border: #b7bdc6;
      margin: 0 2px;
      cursor: pointer;
      transition: 0.2s ease;
    }
  }
  .slick-active {
    button {
      background-color: #333333;
    }
  }

  @media only screen and (max-width: 1080px) {
    picture {
      width: 100%;
    }
  }
  @media only screen and (max-width: 743px){
    .slick-dots-card{
      padding-top: 0px;
    }
  }
`;

export const ButtonClose = styled(Flex)`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #242731;
  justify-content: center;
  cursor: pointer;
`;

export const TitleCarousel = styled(Heading)`
  font-size: 36px;
  margin-bottom: 20px;
  width: 60%;

  @media only screen and (max-width: 1560px){
    width: 100%;
  }

  ${mediaQueries.mediaQueries.xl} {
    font-size: 24px;
  }
  ${mediaQueries.mediaQueries.md} {
    font-size: 20px;
  }
`;
